<template>
    <div id="main">
        <div class="page">
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('contrassenha') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('settings') }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t('contrassenha') }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="permissao.update"
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('gerar-senha-confirmacao') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
            </div>
            <br />
            <div class="columns form-columns-fit is-flex-wrap">
                <div class="column is-4">
                    <!-- 5 caracteres para gerar sem valor extra e 9 caracteres para gerar com valor extra -->
                    <v-input
                        :id="generateId(1)"
                        ref="senhaInput"
                        v-model="user.senha"
                        placeholder="placeholder-preencha"
                        title="senha"
                        :msg="invalidSenhaMsg"
                        :invalid="invalidSenha"
                        :required="true"
                        :onBlurFunction="validateSenha"
                        tooltipLabel="informacao-senha"
                        tooltipSize="is-small"
                        tooltipPosition="is-right"
                        :uppercase="false"
                        :maxlength="10"
                    />
                </div>
                <div class="column is-4">
                    <!-- porcentagem usada para gerar a senha no mobile -->
                    <v-money
                        :id="generateId(3)"
                        ref="valorExtraInput"
                        title="valor-extra"
                        placeholder="placeholder-preencha"
                        v-model="user.valorextra"
                        :max="100"
                        tooltipLabel="informacao-valor-extra"
                        tooltipSize="is-large"
                        tooltipPosition="is-bottom"
                        :disabled="isNull(user.senha) || user.senha.length < 9"
                    />
                </div>
                <div class="column is-4">
                    <v-input
                        :id="generateId(4)"
                        ref="senhaInput"
                        v-model="user.contrassenha"
                        title="contassenha-gerada"
                        :disabled="true"
                        @input-action="copyToClipboard()"
                        :icon="isNull(user.contrassenha) ? null : 'content-copy'"
                        :uppercase="false"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContrasenhaService from '@/services/ContrasenhaService';
import ContrasenhaValidation from '@/services/validations/ContrasenhaValidation';
import Message from '@/models/Message';

export default {
    data() {
        return {
            service: new ContrasenhaService(this.$http, this.$router),
            validation: new ContrasenhaValidation(this.msgs),
            isSaving: false,
            msgs: [],
            invalidSenha: false,
            invalidSenhaMsg: 'msg-campo-obrigatorio',
            user: {
                valorextra: '',
                senha: null,
                contrassenha: null,
                idUsuario: this.$store.state.user.id,
            },
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('admin', 'contrassenha', 'contrassenha');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'contrassenha' },
            });
        }
    },
    watch: {
        user: {
            deep: true,
            handler: function () {
                if (this.isNull(this.user.senha) || this.user.senha.length < 9)
                    this.user.valorextra = 0;
            },
        },
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-assformapagto-' + numberId;
        },
        copyToClipboard() {
            if (!navigator.clipboard) {
                this.selectText(this.$refs.senhaInput.$refs.typed);
                document.execCommand('copy');
                this.msgs.push(new Message('success', 'msg-senha-copiada', true));
            } else {
                navigator.clipboard
                    .writeText(this.user.contrassenha)
                    .then((_) => {
                        this.msgs.push(new Message('success', 'msg-senha-copiada', true));
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('alert', 'msg-senha-erro-copiar', true));
                        console.error('Erro ao copiar: ' + e);
                    });
            }
        },
        selectText(element) {
            let range;
            if (document.selection) {
                range = document.body.createTextRange();
                range.moveToElementText(element);
                range.select();
            } else if (window.getSelection) {
                range = document.createRange();
                range.selectNode(element);
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
            }
        },
        validateSenha() {
            if (this.isNull(this.user.senha)) {
                this.invalidSenha = true;
                this.invalidSenhaMsg = 'msg-campo-obrigatorio';
            } else if (
                !this.isNull(this.user.senha) &&
                this.user.senha.length != 5 &&
                this.user.senha.length < 9
            ) {
                this.invalidSenha = true;
                this.invalidSenhaMsg = 'msg-cinco-caracteres';
            } else {
                this.invalidSenha = false;
            }
        },
        runValidations(focusedOut = false) {
            if (focusedOut) {
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    value.focusedOut = true;
                });
            }
            // Ao realizar o focusedOut no arquivo validation, as funções de validate não são chamadas, tendo assim que faze-las manualmente para poder apresentar os erros nos campos
            this.validateSenha();
        },
        save() {
            if (this.validation.validate(this.user, this.$refs)) {
                let userTemp = Object.assign({}, this.user);
                this.isSaving = true;

                this.service
                    .save(userTemp)
                    .then((value) => {
                        if (value.message == null) {
                            this.msgs.push(new Message('success', 'msg-gerar-contrassenha', true));
                            // this.user = Object.assign({}, value.content);
                            this.user.senha = null;
                            this.user.valorextra = 0;
                            this.user.contrassenha = value.content.contrassenha;
                            setTimeout(() => {
                                this.copyToClipboard();
                            }, 200);
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        console.error('Erro ao salvar: ' + e);
                        let msg = e.message != null ? e.message : 'msg-erro-gerar-contrassenha';
                        this.msgs.push(new Message('error', msg, true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            } else {
                this.runValidations();
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}
.page {
    .altera-usuario {
        position: relative;
        width: 100%;
        margin-bottom: 20px;
        height: 100%;
        padding-top: 0;
    }
}

.altera-usuario .center {
    width: 100%;
    left: 0;
    transform: translateX(0);
    margin: 0;
    box-sizing: border-box;
    position: initial;
    padding-bottom: 20px;
}

.page .form {
    // display: block;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-radius: 2px;
    text-align: left;

    .nome-input {
        width: 49.5%;
    }
    .login-input {
        width: 49.5%;
        input {
            text-transform: none !important;
        }
    }
    .password-input {
        width: 100%;
    }
}

.nav.nav-tabs {
    margin-bottom: 40px;
    margin-left: -40px;
    padding-left: 60px;
    margin-right: 0px;
    padding-right: 20px;
}

.texto-exclusao {
    text-align: justify;
    font-size: 12px;
}
.email-input {
    width: 49.5%;
}
</style>
